import { ISO_FORMAT } from '@hhgtech/hhg-components/constants'
import { LOCALE } from '@hhgtech/hhg-components/types'
import dayjs from 'dayjs'

import { POST_DATE_FORMAT } from 'interfaces/constants'

export function renderDate(
  date?: string,
  locale = LOCALE.PhilippinesEnglish,
  format: string = POST_DATE_FORMAT,
) {
  if (dayjs(date, format).isValid()) {
    return dayjs(date, format).format(ISO_FORMAT[locale].dateFormat)
  } else {
    return date
  }
}
